import getOrganization from './getOrganization';
import getOrganizationDetails from './getOrganizationDetails';
import getLogo from './getLogo';
import getRoleDetails from './getRoleDetails';
import textInputSchema from './textInputSchema';
import dateSchema from './dateSchema';
import contentEditableDivSchema from './contentEditableDivSchema';
import unorderedList from './unorderedList';
import listItem from './listItem';

export default (params) => {
  const { preTag } = params;

  return {
    blocks: {
      [`${preTag}_organization`]: getOrganization(params),
      [`${preTag}_organization_details`]: getOrganizationDetails(params),
      [`${preTag}_logo`]: getLogo(params),
      [`${preTag}_image`]: {
        isVoid: true,
      },
      [`${preTag}_organization_name`]: textInputSchema,
      [`${preTag}_organization_address`]: textInputSchema,
      [`${preTag}_role_details`]: getRoleDetails(params),
      [`${preTag}_award_title`]: textInputSchema,
      [`${preTag}_issue_date`]: dateSchema,
      [`${preTag}_award_description`]: contentEditableDivSchema,
      unordered_list: unorderedList,
      list_item: listItem,
      paragraph: {
        nodes: [
          {
            match: { object: 'text' },
          },
        ],
      },
    },
  };
};
